export default "__VITE_ASSET__Ce6YQh20__"